import React, { useContext } from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import { ListItemText, ListContext } from 'components/List';

export interface SelectItemTextProps extends React.ComponentPropsWithRef<'div'> {
  /** Children, displayed as one item in the dropdown list. */
  children: React.ReactNode;
}

/** Text item to display in a SelectItem dropdown menu. It supports text or marked up html text.
 * Any other props will be provided to the root element.
 */
const SelectItemText = React.forwardRef<HTMLElement, SelectItemTextProps>((props: SelectItemTextProps, ref) => getContext(({ RTL, theme }) => {
  const {
    children,
    ...otherProps
  } = props;
  const listContext = useContext(ListContext);
  const resolvedGlobalTheme = theme && theme.LIST && theme.LIST.VERTICAL;
  const resolvedUserTheme = listContext && listContext.theme;
  const resolvedTheme = _merge({}, resolvedGlobalTheme, resolvedUserTheme);
  return (
    <ListItemText ref={ref} $theme={resolvedTheme} rtl={RTL} {...otherProps} >
      {children}
    </ListItemText>
  );
}));

SelectItemText.displayName = 'SelectItemText';

export { SelectItemText as default };